import { pathRedirect } from '@/utils/auth'
import NoticeView from '@/containers/Notice/NoticeView'

export default {
  path: 'notice',
  redirect: pathRedirect,
  children: [
    { path: 'noticeList', component: NoticeView, name: '通知中心' }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/notice.js